import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

const STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes, chosen arbitrarily

export function useOrg(orgId: string | undefined) {
  const { orgService } = useDomainServices();

  return useQuery({
    queryKey: ["org", orgId],
    queryFn: ({ signal }) => {
      if (orgId === undefined) {
        return Promise.reject(new Error("Invalid orgId"));
      }

      return orgService.getOrg(orgId, {
        abortSignal: signal,
      });
    },
    enabled: orgId !== undefined,
    staleTime: STALE_TIME_MS,
  });
}
